module.exports = __webpack_public_path__ + "img/logo-choco.9c4fdb31.png";